export type disputedRegionsCountryCode = {
  iso2: string
  iso3: string
}

export const getDisputedRegionIso3 = (
  iso2: string,
  countryCodes: disputedRegionsCountryCode[]
): string | undefined => {
  const countryCode = countryCodes.find((cc) => cc.iso2 === iso2.toLowerCase())

  return countryCode !== undefined ? countryCode.iso3.toUpperCase() : undefined
}
